import React from "react";

const useBundlesSettings = () => {
	const [pricingDisabled, setPricingsDisabled] = React.useState(false);
	const [showChildItems, setShowChildItems] = React.useState<boolean>(false);
	const [showQuantity, setShowQuantity] = React.useState<boolean>(false);
	const [showPrice, setShowPrice] = React.useState<boolean>(false);

	const handleChangeChildItems = () => {
		setShowChildItems(!showChildItems);
		setShowQuantity(!showQuantity);
		if (showPrice) {
			setShowPrice(!showPrice);
		}
	};

	const handleChangeQuantity = () => {
		if (showQuantity) {
			setShowQuantity(false);
			setShowPrice(false);
		} else {
			setShowQuantity(true);
		}
	};
	const handleChangePrice = () => {
		if (showPrice) {
			setShowPrice(false);
		} else {
			setShowPrice(true);
			if (!showQuantity) {
				setShowQuantity(true);
			}
		}
	};

	React.useEffect(() => {
		if (showChildItems && showPrice) {
			setPricingsDisabled(true);
		} else {
			setPricingsDisabled(false);
		}
	}, [showChildItems, showQuantity, showPrice]);

	return {
		pricingDisabled,
		showChildItems,
		showQuantity,
		showPrice,
		setShowChildItems,
		setShowQuantity,
		setShowPrice,
		handleChangeChildItems,
		handleChangeQuantity,
		handleChangePrice
	};
};

export default useBundlesSettings;
